import { render, staticRenderFns } from "./ordersTab.vue?vue&type=template&id=c5c67d9c&"
import script from "./ordersTab.vue?vue&type=script&lang=js&"
export * from "./ordersTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports